import axios from "axios";

// Constants
const API_BASE_URL = "https://api.miplapp.in/public/api";
const WEB_BASE_URL = "https://pdcare.miplapp.in";

export const logout = async (options = {}) => {
  const {
    redirect = true,
    //redirectPath = "/login",
    silent = false,
  } = options;

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  // Enhanced storage cleanup
  const clearAuthData = () => {
    // LocalStorage
    const localStorageItems = [
      "token", "refreshToken", "All", "user", 
      "cachedDealers", "cachedDealersTimestamp",
      "cachedPatients", "cachedUsers"
    ];
    
    localStorageItems.forEach(item => localStorage.removeItem(item));
    
    // SessionStorage
    sessionStorage.clear();
    
    // Axios headers
    delete axios.defaults.headers.common['Authorization'];
  };

  if (!token) {
    !silent && console.warn("No authentication token found");
    clearAuthData();
    if (redirect) {
     window.location.href = `${WEB_BASE_URL}`;
    }
    return;
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        timeout: 5000
      }
    );

    if (response.status === 200) {
      !silent && console.log("Logout successful");
    } else {
      !silent && console.warn("Logout completed with non-200 status:", response.status);
    }
  } catch (error) {
    if (!silent) {
      if (error.response) {
        console.error("Logout failed - Server responded with:", error.response.status);
      } else if (error.request) {
        console.error("Logout failed - No response received");
      } else {
        console.error("Logout failed - Request error:", error.message);
      }
    }
  } finally {
    clearAuthData();
    if (redirect) {
      window.location.href = `${WEB_BASE_URL}`;//useWebUrl ? `${WEB_BASE_URL}${redirectPath}` : redirectPath;
      
      // Consider adding this to prevent race conditions
      window.location.reload();
    }
  }
};
/*
import axios from "axios";

export const logout = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.error("No token found in localStorage");
    window.location.href = "/login"; // Redirect to login
    return;
  }

  try {
    const response = await axios.post("https://api.miplapp.in/public/api/logout", {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (response.status === 200) {
      console.log("Logged out successfully");
      localStorage.removeItem("token"); // Clear the token
      localStorage.removeItem("All");
      localStorage.removeItem("user");
      localStorage.removeItem("cachedDealers");
      localStorage.removeItem("cachedDealersTimestamp");
      localStorage.removeItem("cachedPatients");
      localStorage.removeItem("cachedUsers");
      window.sessionStorage.clear();
      window.location.href = "/"; // Redirect to login
    } else {
      console.error("Logout failed with status:", response.status);
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized: Invalid token or session expired");
      window.location.href = "/login"; // Redirect to login
    } else {
      console.error("Logout failed:", error);
    }
  }
};
*/